import { render, staticRenderFns } from "./itemsenriquecidos.vue?vue&type=template&id=5e63138d&scoped=true"
import script from "./itemsenriquecidos.vue?vue&type=script&lang=js"
export * from "./itemsenriquecidos.vue?vue&type=script&lang=js"
import style0 from "./itemsenriquecidos.vue?vue&type=style&index=0&id=5e63138d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e63138d",
  null
  
)

export default component.exports